.modal-body {
	display: flex;
	flex-direction: column;
	align-items: center;
}
